module.exports = __webpack_public_path__ + "static/media/footer-logo.88d8454a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/footer-logo.svg
// module id = 1086
// module chunks = 49